import { Controller } from "stimulus"

import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/animations/shift-away.css';

export default class extends Controller {
  static targets = [ "text" ]

  connect() {
    this.textTargets.forEach((target) => {
      tippy(target, {
        animation: 'shift-away'
      });
    })
  }
}
